import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { TextInput } from "@common/textInput";
import { SelectList } from "@common/selectList";
import { ColorPickerInput } from "./colorPickerInput";
import { ProjectAdequacyInput } from "./projectAdequacyInput";
import { StrategicAxisCode } from "./tag";
import { Props } from "./types";
import styles from "./styles.scss";

function Form({ formData, edit }: Props) {
  const { t } = useTranslation();

  const adequacyPossibilities = [
    {
      value: "-2",
      index: "-2",
      placeholder: t("strategicAxesPage.creation.placeholders.levelOne"),
    },
    {
      value: "-1",
      index: "-1",
      placeholder: t("strategicAxesPage.creation.placeholders.levelTwo"),
    },
    {
      value: "0",
      index: "0",
      placeholder: t("strategicAxesPage.creation.placeholders.levelThree"),
    },
    {
      value: "1",
      index: "1",
      placeholder: t("strategicAxesPage.creation.placeholders.levelFour"),
    },
    {
      value: "2",
      index: "2",
      placeholder: t("strategicAxesPage.creation.placeholders.levelFive"),
    },
  ];

  return (
    <div className={styles.form}>
      <div className={styles.row}>
        <div className={styles.group}>
          <h2 className={styles.label}>
            {t("strategicAxesPage.creation.code")}
          </h2>
          <div className={styles.row}>
            <ColorPickerInput
              strategicAxis={formData}
              setStrategicAxis={edit}
            />
            {!!formData.code && (
              <StrategicAxisCode code={formData.code} color={formData.color} />
            )}
          </div>
        </div>
      </div>
      <div className={styles.group}>
        <h2 className={styles.label}>{t("strategicAxesPage.creation.axe")}</h2>
        <TextInput
          placeholder={t("strategicAxesPage.creation.placeholders.axeName")}
          value={formData.name}
          input={(name) => edit({ ...formData, name })}
          autoFocus
        />
      </div>
      <div className={styles.horizontalRow}>
        <h2 className={styles.label}>
          {t("strategicAxesPage.creation.weight")}
        </h2>
        <SelectList rootClassName={styles.root} listClassName={styles.listRoot}>
          {({ isOpen, select }) => ({
            input: (
              <div
                className={classNames(styles.input, {
                  [styles.opened]: isOpen,
                })}
              >
                <p className={styles.placeholder}>{formData.weight}</p>
                <ToggleArrowIcon className={styles.icon} />
              </div>
            ),
            list: (
              <div className={styles.list}>
                {[1, 2, 3, 4, 5].map((weight) => (
                  <div
                    key={weight}
                    className={classNames(styles.option, {
                      [styles.selected]: weight === formData.weight,
                    })}
                    onClick={() => {
                      edit({ ...formData, weight });
                      select(weight);
                    }}
                  >
                    <p className={styles.option}>{weight}</p>
                  </div>
                ))}
              </div>
            ),
          })}
        </SelectList>
      </div>
      <div className={styles.group}>
        <h2 className={styles.label}>
          {t("strategicAxesPage.creation.strategicProjectAdequacy")}
        </h2>
        {adequacyPossibilities.map((adequacyPossibility) => (
          <ProjectAdequacyInput
            key={adequacyPossibility.index}
            strategicAxis={formData}
            setStrategicAxis={edit}
            adequacyValue={adequacyPossibility.value}
            index={adequacyPossibility.index}
            placeholder={adequacyPossibility.placeholder}
          />
        ))}
      </div>
    </div>
  );
}

export { Form };
